export default __webpack_public_path__ + "static/media/photo--sm--matt-3.a47602a4.jpg";